import { CardAdvancement, CardGrade } from '@cta-portal/webapp-common/lib/api/schema';
export function getFormatedSupply(advancement, input) {
    var _a, _b;
    var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    return [
        (_a = {
                foil: false
            },
            _a[CardGrade.C] = advancement !== CardAdvancement.STANDARD
                ? (_c = input.find(function (card) { return !card.foil && card.grade === CardGrade.C; })) === null || _c === void 0 ? void 0 : _c.count
                : undefined,
            _a[CardGrade.B] = advancement !== CardAdvancement.STANDARD
                ? (_d = input.find(function (card) { return !card.foil && card.grade === CardGrade.B; })) === null || _d === void 0 ? void 0 : _d.count
                : undefined,
            _a[CardGrade.A] = advancement !== CardAdvancement.STANDARD
                ? (_e = input.find(function (card) { return !card.foil && card.grade === CardGrade.A; })) === null || _e === void 0 ? void 0 : _e.count
                : undefined,
            _a[CardGrade.S] = advancement !== CardAdvancement.STANDARD
                ? (_f = input.find(function (card) { return !card.foil && card.grade === CardGrade.S; })) === null || _f === void 0 ? void 0 : _f.count
                : undefined,
            _a[1] = advancement === CardAdvancement.STANDARD
                ? (_g = input.find(function (card) { return !card.foil && card.rank === 1; })) === null || _g === void 0 ? void 0 : _g.count
                : undefined,
            _a[2] = advancement === CardAdvancement.STANDARD
                ? (_h = input.find(function (card) { return !card.foil && card.rank === 2; })) === null || _h === void 0 ? void 0 : _h.count
                : undefined,
            _a[3] = advancement === CardAdvancement.STANDARD
                ? (_j = input.find(function (card) { return !card.foil && card.rank === 3; })) === null || _j === void 0 ? void 0 : _j.count
                : undefined,
            _a[4] = advancement === CardAdvancement.STANDARD
                ? (_k = input.find(function (card) { return !card.foil && card.rank === 4; })) === null || _k === void 0 ? void 0 : _k.count
                : undefined,
            _a[5] = advancement === CardAdvancement.STANDARD
                ? (_l = input.find(function (card) { return !card.foil && card.rank === 5; })) === null || _l === void 0 ? void 0 : _l.count
                : undefined,
            _a),
        (_b = {
                foil: true
            },
            _b[CardGrade.C] = advancement !== CardAdvancement.STANDARD
                ? (_m = input.find(function (card) { return card.foil && card.grade === CardGrade.C; })) === null || _m === void 0 ? void 0 : _m.count
                : undefined,
            _b[CardGrade.B] = advancement !== CardAdvancement.STANDARD
                ? (_o = input.find(function (card) { return card.foil && card.grade === CardGrade.B; })) === null || _o === void 0 ? void 0 : _o.count
                : undefined,
            _b[CardGrade.A] = advancement !== CardAdvancement.STANDARD
                ? (_p = input.find(function (card) { return card.foil && card.grade === CardGrade.A; })) === null || _p === void 0 ? void 0 : _p.count
                : undefined,
            _b[CardGrade.S] = advancement !== CardAdvancement.STANDARD
                ? (_q = input.find(function (card) { return card.foil && card.grade === CardGrade.S; })) === null || _q === void 0 ? void 0 : _q.count
                : undefined,
            _b[1] = advancement === CardAdvancement.STANDARD
                ? (_r = input.find(function (card) { return card.foil && card.rank === 1; })) === null || _r === void 0 ? void 0 : _r.count
                : undefined,
            _b[2] = advancement === CardAdvancement.STANDARD
                ? (_s = input.find(function (card) { return card.foil && card.rank === 2; })) === null || _s === void 0 ? void 0 : _s.count
                : undefined,
            _b[3] = advancement === CardAdvancement.STANDARD
                ? (_t = input.find(function (card) { return card.foil && card.rank === 3; })) === null || _t === void 0 ? void 0 : _t.count
                : undefined,
            _b[4] = advancement === CardAdvancement.STANDARD
                ? (_u = input.find(function (card) { return card.foil && card.rank === 4; })) === null || _u === void 0 ? void 0 : _u.count
                : undefined,
            _b[5] = advancement === CardAdvancement.STANDARD
                ? (_v = input.find(function (card) { return card.foil && card.rank === 5; })) === null || _v === void 0 ? void 0 : _v.count
                : undefined,
            _b),
    ];
}
